import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'angular-highcharts';
import { AggregatedMonthsComponent } from './aggregated-months.component';

@NgModule({
  declarations: [
    AggregatedMonthsComponent
  ],
  imports: [
    CommonModule,
    ChartModule
  ],
  exports: [
    AggregatedMonthsComponent
  ]
})
export class AggregatedMonthsModule {}
